import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';
import { queryClient } from '../../queryClient';

interface HookProps {
  date: string;
}

export const useGenerateDailyReport = () => {
  return useMutation({
    mutationFn: async ({ date }: HookProps) => {
      await request(
        {
          path: `declarations/generate-daily-report`,
          method: 'POST',
          authenticate: true,
          fileDownload: true,
          dataObject: { date },
        },
        true,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
      toast.success('The report is being generated.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the report!');
    },
  });
};
